// @ts-ignore
import Vue from 'vue';
// @ts-ignore
import { Component, Prop } from "vue-property-decorator";

//Components
import WithRender from "Components/Search/PagesSearchCard/PageContentTypes/News/newsarticle.html";


@WithRender
@Component()

export default class newsarticle extends Vue {
	@Prop({}) title: string;
	@Prop({}) url: string;
	@Prop({}) highlightResults: any;
	@Prop({}) imageUrl: string;
}
